import $ from 'jquery';

import './toggle-favorite';
import './fields/validator';
import './fields/invalidate';
import './fields/error-summary';

import './fields/form-field';
import './fields/validate-field';

$(document).ready(() => {
  //$('.js-favorite-button').toggleFavorite();

  $(document.querySelectorAll('[data-validate]'))
    .validator()
    .errorSummary();

  $(document.body).formField();
});



// WEBPACK FOOTER //
// ./styleguide/src/assets/elements/elements.js